import { AlertTriangle } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { fmtDate } from "@/lib/format";
import { earliestCheckout } from "@/lib/minStay";

/** Gelbe Box direkt am Kalender/Datumsfeld, wenn der gewählte Zeitraum unter dem Mindestaufenthalt liegt – mit Ein-Klick-Korrektur der Abreise. */
export const MinStayNotice = ({ quote, range, availability, onFix, className = "", testId = "min-stay-notice" }) => {
  const { t, lang } = useLang();
  if (!quote || quote.min_nights_ok !== false || !range?.from || !range?.to) return null;
  const nights = Math.max(0, Math.round((range.to - range.from) / 86400000));
  const to = earliestCheckout(range.from, quote.min_nights, availability);
  return (
    <div className={`rounded-md border border-amber-300 bg-amber-50 text-amber-900 text-xs px-3 py-2 flex flex-wrap items-center gap-2 ${className}`} role="alert" data-testid={testId}>
      <AlertTriangle className="w-4 h-4 shrink-0 text-amber-600" />
      <span className="flex-1 min-w-[12rem]">{t.booking.minNights.replace("{n}", quote.min_nights)} – {t.booking.minStayChosen.replace("{c}", nights)}</span>
      {to && onFix
        ? <button type="button" onClick={() => onFix({ from: range.from, to })} className="rounded-md bg-amber-600 px-2.5 py-1 font-medium text-white hover:bg-amber-700 transition-colors whitespace-nowrap" data-testid={`${testId}-fix`}>{t.booking.setCheckout.replace("{date}", fmtDate(to, lang))}</button>
        : <span className="basis-full text-amber-800">{t.booking.minStayBlocked.replace("{n}", quote.min_nights).replace("{date}", fmtDate(range.from, lang))}</span>}
    </div>
  );
};
